import axios from '../axios'

// 受講登録一覧（admin）。params = { course_id?, student_id? }
const getEnrollmentsApi = async (params = {}) => {
  return await axios.get('api/lms/enrollments', { params })
}

export default getEnrollmentsApi
